import './Impermeabilizantes.css';
import React from "react";
import { Link } from "react-router-dom";
import Impermeabilizantes1 from '../../assets/Productos/Impermeabilizantes/Impermeabilizantes1.png';
import Impermeabilizantes2 from '../../assets/Productos/Impermeabilizantes/Impermeabilizantes2.png';
import Impermeabilizantes3 from '../../assets/Productos/Impermeabilizantes/Impermeabilizantes3.png';
import Impermeabilizantes4 from '../../assets/Productos/Impermeabilizantes/Impermeabilizantes4.png';
import Impermeabilizantes5 from '../../assets/Productos/Impermeabilizantes/Impermeabilizantes5.png';
import Impermeabilizantes6 from '../../assets/Productos/Impermeabilizantes/Impermeabilizantes6.png';
import Impermeabilizantes7 from '../../assets/Productos/Impermeabilizantes/Impermeabilizantes7.png';


const images = [
    { src: Impermeabilizantes1, text: "MF886F Sellador ácido de temperatura", id: 41 },
    { src: Impermeabilizantes2, text: "MF521 Sellador de polisulfuro para protección de pernos", id: 42 },
    { src: Impermeabilizantes3, text: "MF860F Sellador de polisulfuro anticorrosivo", id: 43 },
    { src: Impermeabilizantes4, text: "MF860L Sellador termoconductor de silicona", id: 44 },
    { src: Impermeabilizantes5, text: "MF2000B Sellador anticorrosivo", id: 45 },
    { src: Impermeabilizantes6, text: "MF2000G Sellador anticorrosivo", id: 46 },
    { src: Impermeabilizantes7, text: "MF2000H Sellador impermeable", id: 47 },
];

function Impermeabilizantes() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <Link to={`/productos/${item.id}`}>
                            <img src={item.src} alt={item.text} />
                        </Link>
                        <p>{item.text}</p> {/* Nombre del producto sin enlace */}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Impermeabilizantes;
